module.exports = __webpack_public_path__ + "static/media/downer-logo.a6985b0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/downer-logo.jpg
// module id = 280
// module chunks = 0